var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIconGreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail-icon--green-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Pro-14\"-Copy",
    transform: "translate(-830, -514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail-icon--green-2",
    transform: "translate(830, 514)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#EDEDED",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-email-7009429",
    transform: "translate(11, 14)",
    fill: "#82BC00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.156594286,1.52175188 C0.272664229,1.2154979 0.449095771,0.934259193 0.680070857,0.69832252 C1.11532571,0.250244185 1.70613486,0 2.32130971,0 L23.6784526,0 C24.2936274,0 24.8844366,0.250247235 25.3196914,0.69832252 C25.5506725,0.935461146 25.7282629,1.21668765 25.843168,1.52294163 L13.2576823,10.5653504 C13.1160759,10.6463846 12.9477623,10.6463846 12.8096503,10.5701173 C12.8026861,10.5665422 2.662816,3.31416467 0.156594286,1.52191234 L0.156594286,1.52175188 Z M26,3.73703677 L26,16.6833524 C26,17.3149269 25.7562507,17.9214861 25.3198103,18.3683441 C24.8845554,18.8164225 24.2937463,19.0666667 23.6785714,19.0666667 L2.32142857,19.0666667 C1.70625371,19.0666667 1.11544457,18.8164194 0.680189714,18.3683441 C0.243746286,17.9214861 0,17.3149269 0,16.6833524 L0,3.73246081 L11.7683429,12.1504031 C11.7834321,12.1611279 11.7985207,12.1706612 11.8136096,12.1801944 C12.5611022,12.6520983 13.5036096,12.6509085 14.2499433,12.1766194 C14.2650325,12.1670861 14.2789614,12.1575529 14.2940512,12.1480196 L26,3.73703677 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconGreen2);
export default __webpack_public_path__ + "static/media/mail-icon--green-2.78c8be32fbbbc1d9fab63423d2ff32a0.svg";
export { ForwardRef as ReactComponent };